//#region src/components/CopyButton/test.ts
var e = /* @__PURE__ */ function(e) {
	return e.copyButton = "copy-button", e;
}({});
//#endregion
export { e as TestAnchors };
